<template>
    <v-data-table
        :headers="headers"
        :items="list"
        item-key="id"
        :disable-pagination="false"
        :hide-default-footer="false"
        :fixed-header="true"
        :search="search"
        @click:row="articleSelected"
    >
        <template v-slot:item.id="{ item }">
            <v-chip :color="getColor(item.is_published)">{{ item.id }}</v-chip>
        </template>
    </v-data-table>
</template>

<script>

    export default {
        name: "article_list",

        components: {},

        props: {
            list: {},
            search: ''
        },

        data: () => ({
            headers: [
                {text: '#', align: 'left', value: 'id', sortable: true},
                {text: 'Article title', align: 'left', value: 'title', sortable: true},
                {text: 'Unique views', align: 'center', value: 'views_count_unique', sortable: true},
                {text: 'Created at', align: 'right', value: 'created_at', sortable: false},
                {text: 'Published at', align: 'right', value: 'published_from', sortable: false},
            ],
        }),

        computed: {},

        watch: {},

        methods: {
            articleSelected(payload) {
                this.$emit('openArticle', payload.id);
            },

            getColor(published) {
                if (published) return 'green';

                return 'red'
            },
        },

        created() {

        },

        mounted() {

        }
    }
</script>
